<template>
  <div>
    <div class="header-container">
      <h3 class="chart-title">每月销量额走势图</h3>
      <el-select v-model="selectedYear" placeholder="请选择年度" @change="updateChart">
        <el-option
            v-for="year in yearOptions"
            :key="year"
            :label="`${year}年度`"
            :value="year"
        />
      </el-select>
    </div>
    <!-- 图表区域 -->
    <div v-loading="loading" element-loading-text="折线图正在更新中..." id="sales-chart" style="width: 100%; height: 400px;"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'SalesChart',
  data() {
    return {
      chart: null, // 图表实例
      selectedYear: new Date().getFullYear(), // 默认选中当前年度
      yearOptions: this.getYearOptions(), // 可选年度列表
      salesData: null, // 存储后端返回的数据，
      loading: false,
    };
  },
  mounted() {
    this.initChart();
    this.updateChart(); // 页面加载时先进行一次查询并渲染
  },
  methods: {
    // 获取年度选项
    getYearOptions() {
      const startYear = 2024; // 起始年度
      const currentYear = new Date().getFullYear();
      return Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i);
    },

    // 初始化图表
    initChart() {
      this.chart = echarts.init(document.getElementById('sales-chart'));
    },

    // 更新图表
    updateChart() {
      const logininfo=JSON.parse(localStorage.getItem("logininfo"));// 从localStorage获取logininfoId
      const logininfoId=logininfo.id;
      const year = this.selectedYear;
      this.loading = true;
      // 发送请求到后端获取数据
      this.$http.get("/employeeRanking/amount", {
        params: {
          year: year,
          logininfoId: logininfoId,
        },
      }).then(response => {
        this.salesData = response.data; // 假设后端返回的数据为数组形式
        this.renderChart();

      }).catch(error => {
        console.error('Error fetching data:', error);
      }).finally(() => {
        // 数据加载完成后，关闭加载动画
        this.loading = false;
      });
    },

    // 渲染图表
    renderChart() {
      const { xAxisData, seriesData } = this.formatData();

      const option = {
        title: {
          text: `${this.selectedYear} 年度个人销售额走势图`,
          left: 'center',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
          },
        },
        legend: {
          data: ['总销售额', '待发货订单', '已发货订单', '交易成功订单', '取消订单','审核中订单'],
          bottom: 0,
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          name: '月份',
        },
        yAxis: {
          type: 'value',
          name: '金额',
        },
        series: [
          {
            name: '总销售额',
            type: 'line',
            smooth: true, // 圆滑曲线
            data: seriesData.totalSales,
            lineStyle: {
              color: '#5470C6', // 蓝色
            },
          },
          {
            name: '待发货订单',
            type: 'line',
            smooth: true,
            data: seriesData.pendingOrders,
            lineStyle: {
              color: '#91CC75', // 绿色
            },
          },
          {
            name: '已发货订单',
            type: 'line',
            smooth: true,
            data: seriesData.shippedOrders,
            lineStyle: {
              color: '#FAC858', // 黄色
            },
          },
          {
            name: '交易成功订单',
            type: 'line',
            smooth: true,
            data: seriesData.completedOrders,
            lineStyle: {
              color: '#EE6666', // 红色
            },
          },
          {
            name: '取消订单',
            type: 'line',
            smooth: true,
            data: seriesData.canceledOrders,
            lineStyle: {
              color: '#73C0DE', // 青色
            },
          },

        ],
      };

      this.chart.setOption(option);
    },

    // 格式化数据
    formatData() {
      const xAxisData = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];

      // 初始化所有月份的值为0
      const seriesData = {
        totalSales: Array(12).fill(0),
        pendingOrders: Array(12).fill(0),
        shippedOrders: Array(12).fill(0),
        completedOrders: Array(12).fill(0),
        canceledOrders: Array(12).fill(0),
      };

      if (this.salesData) {
        this.salesData.forEach(item => {
          const month = item.month - 1; // 获取月份索引
          seriesData.totalSales[month] = item.totalSales;
          seriesData.pendingOrders[month] = item.pendingOrders;
          seriesData.shippedOrders[month] = item.shippedOrders;
          seriesData.completedOrders[month] = item.completedOrders;
          seriesData.canceledOrders[month] = item.canceledOrders;
        });
      }

      return { xAxisData, seriesData };
    },
  },
};
</script>

<style scoped>
#sales-chart {
  width: 100%;
  height: 400px;
}
.header-container {
  display: flex;
  justify-content: space-between; /* 左右分布 */
  align-items: center; /* 垂直居中 */
  margin-bottom: 16px; /* 与图表的间距 */
}

.chart-title {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  color: #333;
}
.el-select {
  margin-bottom: 20px;
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// mydateAmount.vue?481efc25